export default __webpack_public_path__ + "static/media/footer logo.151733e6.png";